export default {
    ZINDAGI_PLUS: "400381",
    SIMPLY_PROTECT: "400121",
    ACTIVE_INCOME_PLAN: "400351",
    THREE_GENERATION_PLAN_ACTIVE_INCOME_PLAN: "400352",
    ACTIVE_INCOME_PLAN_WITH_FIB: "400355",
    WHOLE_LIFE_ACTIVE_INCOME_ACTIVE_INCOME_PLAN: "400353",
    RETIRE_BEFIKER_ACTIVE_INCOME_PLAN: "400354",
    WEALTH_ULTIMA: "400731",
    SYSTEMATIC_WITHDRAWAL_PLAN_WEALTH_ULTIMA: "400732",
    LITTLE_CHAMP_WEALTH_ULTIMA: "400093",
    CRITICARE_PLUS: "400141",
    SMART_LIFESTYLE: "400051",
    FAMILY_PROTECTION_OPTION_SMART_LIFESTYLE: "400052",
    GCAP: "400071",
    CASH_FLOW_PROTECTION_PLUS: "400041",
    WEALTH_GAIN_PLUS: "400301",
    WEALTH_SECURE_PLUS: "400311",
    CHILD_VARIANT_WEALTH_SECURE_PLUS: "400313",
    SYSTEMATIC_WITHDRAWAL_PLAN_WEALTH_SECURE_PLUS: "400312",
    DHAN_LABH: "400151",
    WEALTH_PLUS: "400231",
    RISING_STAR_WEALTH_PLUS: "400232",
    INCOME_BUILDER: "400601",
    SECURED_INCOME_OPTION_INCOME_BUILDER: "400602",
    // IMMEDIATE_ANNUITY_PLAN: "Immediate Annuity Plan",
    EASY_PENSION: "400321",
    SINGLE_PAY_ENDOWMENT_ASSUARANCE_PLAN: "400191",
    POS_SARAL_NIVESH: "400591",
    WEALTH_PREMIER: "400341",
    // PROTECTION_REG_5_10_15PAY: "Protection  - (Reg/5/10/15Pay)",
    SARAL_JEEVAN_BIMA: "400391",
    POS_SARAL_JEEVAN_BIMA: "400392",
    SARAL_PENSION: "400411",
    // FOREVER_PENSION: "Forever Pension",
    POS_FOREVER_PENSION: "400403",
    FOREVER_PENSION_DEFERRED_ANNUITY: "400402",
    FOREVER_PENSION_IMMEDIATE_ANNUITY: "400401",
    TOTAL_PROTECT_PLUS: "400441",
    PREMIER_GUARANTEED_SHORT_TERM_INCOME: "400612",
    PREMIER_GUARANTEED_LONG_TERM_INCOME: "400613",
    PREMIER_GUARANTEED_INCOME_LUMPSUM: "400611",
    PREMIER_GUARANTEED_RETIREMENT_INCOME: "400614",
    PREMIER_GUARANTEED_INCOME_LUMPSUM_FIB: "400615",
    PREMIER_GUARANTEED_SHORT_TERM_INCOME_FIB: "400616",
    PREMIER_GUARANTEED_LONG_TERM_INCOME_FIB: "400617",
    GUARANTEED_INCOME_STAR_MILESTONES_GUARANTEED: "400621",
    GUARANTEED_INCOME_STAR_CASHBACK_GUARANTEED: "400622",
    GUARANTEED_INCOME_STAR_BETTER_INNINGS: "400623",
    GUARANTEED_INCOME_STAR: "400624",
    GUARANTEED_INCOME_STAR_CASHBACK_GUARANTEED_FIB: "400625",
    GUARANTEED_INCOME_STAR_BETTER_INNINGS_FIB: "400626",
    GUARANTEED_INCOME_STAR_FIB: "400627",
    POS_GUARANTEED_INCOME_STAR: "400628",
    POS_GUARANTEED_INCOME_STAR_CASHBACK_GUARANTEED: "400629",
    POS_GUARANTEED_INCOME_STAR_BETTER_INNINGS: "4006210",
    GUARANTEED_SAVINGS_STAR_LUMPSUM: "400631",
    GUARANTEED_SAVINGS_STAR_INCOME: "400632",
    GUARANTEED_SAVINGS_STAR_LUMPSUM_FIB: "400633",
    GUARANTEED_SAVINGS_STAR_INCOME_FIB: "400634",
    GUARANTEED_SAVINGS_STAR: "400635",
    FLEXI_SAVINGS_PLAN_CHILD_SYSTEMATIC_WITHDRAWAL: "400641",
    FLEXI_SAVINGS_PLAN_CHILD_AGE_BASED_WITHDRAWAL: "400642",
    FLEXI_SAVINGS_PLAN_CHILD_AGE_PLUS_INCOME_BASED_WITHDRAWAL: "400643",
    FLEXI_SAVINGS_PLAN_CHILD_FLEXI_INCOME: "400644",
    FLEXI_SAVINGS_PLAN_CHILD_FLEXI_INCOME_PRO: "400645",
    FLEXI_SAVINGS_PLAN_CHILD_LARGE_SUM_OPTION: "400646",
    FLEXI_SAVINGS_PLAN_SYSTEMATIC_WITHDRAWAL: "400647",
    FLEXI_SAVINGS_PLAN_AGE_BASED_WITHDRAWAL: "400648",
    FLEXI_SAVINGS_PLAN_AGE_PLUS_INCOME_BASED_WITHDRAWAL: "400649",
    FLEXI_SAVINGS_PLAN_FLEXI_INCOME: "4006410",
    FLEXI_SAVINGS_PLAN_FLEXI_INCOME_PRO: "4006411",
    FLEXI_SAVINGS_PLAN_LARGE_SUM_OPTION: "4006412",
    ZINDAGI_PROTECT: "400691",
    BHARAT_SAVINGS_STAR_INCOME: "400661",
    BHARAT_SAVINGS_STAR_LUMPSUM: "400662",
    POS_BHARAT_SAVINGS_STAR_INCOME: "400663",
    POS_BHARAT_SAVINGS_STAR_LUMPSUM: "400664",
    LEGACY_PLUS_INCOME: "400681",
    LEGACY_PLUS_LUMPSUM: "400682",
    ACTIVE_PENSION_PLUS: "400741",
    GUARANTEED_FLEX_STAR: "400711",
    NEW_GUARANTEED_INCOME_STAR_NON_PAR_MILESTONES_GUARANTEED: "400621",
    NEW_GUARANTEED_INCOME_STAR_NON_PAR_CASHBACK_GUARANTEED: "400622",
    NEW_GUARANTEED_INCOME_STAR_NON_PAR_BETTER_INNINGS: "400623",
    NEW_GUARANTEED_INCOME_STAR_NON_PAR_CASHBACK_GUARANTEED_FIB: "400625",
    NEW_GUARANTEED_INCOME_STAR_NON_PAR_BETTER_INNINGS_FIB: "400626",
    NEW_GUARANTEED_INCOME_STAR_NON_PAR_FIB: "400627",
    POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR: "400628",
    POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR_CASHBACK_GUARANTEED: "400629",
    POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR_BETTER_INNINGS: "4006210",
    FLEXI_DREAM_PLAN: "400751",
    ASSURED_INCOME_STAR: "400771",
    FLEXI_GOAL_SECURE: "400781",
    PREMIER_GUARANTEED_STAR_PRO: "400761",
};